
import { ScrapCauseModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { scrapCausesStore } from '@/libs/scrap-causes/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import ScrapCauseDialog from '../components/ScrapCauseDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        ScrapCauseDialog,
    },
})
export default class ScrapCauses extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('scrapCauses.name'), value: 'name', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: ScrapCauseDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return scrapCausesStore.useGetter(CrudGetter.Pending);
    }

    get items(): ScrapCauseModel[] {
        return [...scrapCausesStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...scrapCausesStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        scrapCausesStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<ScrapCauseModel>({ field: 'name', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: ScrapCauseModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
